import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

interface StampActionsProps {
  uploading: boolean;
  onUpload: () => void;
  onRefresh: () => void;
}

export const StampActions: React.FC<StampActionsProps> = ({
  uploading,
  onUpload,
  onRefresh,
}) => {
  return (
    <div className="text-center mt-4">
      <Button
        variant="outline-primary"
        onClick={onUpload}
        disabled={uploading}
        className="me-3"
      >
        {uploading ? (
          <>
            <Spinner animation="border" size="sm" className="me-2" />
            Przesyłanie...
          </>
        ) : (
          <>
            <Icon.Upload className="me-2" />
            Prześlij wszystkie pieczątki
          </>
        )}
      </Button>
      <Button variant="outline-secondary" onClick={onRefresh}>
        <Icon.ArrowClockwise className="me-2" />
        Odśwież
      </Button>
    </div>
  );
};
